module.exports = __webpack_public_path__ + "img/gongzhonghao.d3158d81.png";